import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router';
import Footer from '../../common/footer/footer';
import { getAnswer } from '../../services/getData';
import "./results.css"
import { useNavigate, } from 'react-router';
import SearchResult from './searchResult/searchResult';
import { Context } from '../../context/ContextData';


const Results = () => {


  const { answer,
    similarQuestion,
    showMore,
    find,
    findSimilar,
    setPageSize,
    setAnswerSize,
    setAnswer,
    setSimilarQuestion,
    setChatBitId,
    loading,
    setLoading
  } = useContext(Context);


  const navigate = useNavigate();
  let search = useParams();

  useEffect(() => {

    // const show = document.querySelector(".for-more")

    window.addEventListener('resize', function (event) {
      setPageSize(window.innerWidth)
    })

  }, [window.innerWidth]);

  useEffect(() => {
    setPageSize(window.innerWidth)
  }, [])

  useEffect(() => {
    setLoading(true)
    const searchText = `${search.id}`
    getAnswer(searchText).then(res => {
      setAnswer(res.data);
      setAnswerSize(res.data.answer.length);
      setSimilarQuestion(res.data.similar_questions)
      // setChatBitId(res.data.id)
      // sessionStorage.setItem("user_id", res.data.user_id)
    }).then(()=>{
      setLoading(false)
    }).catch(()=>{
      setLoading(false)
    })
  }, []);





  return (

    <div className='answer-parent'>

      <SearchResult />
      {loading ?
        <div className='d-flex justify-content-center'>
          <img src='/images/Rolling.svg'></img>
        </div>
        :
        <>
          <div className='container d-flex flex-column justify-content-center align-content-center mx-auto text-right mb-4 mt-3'>
            <div className="row mt-4">
              <div id="transition" className="d-flex flex-column col-10 p-0 mx-auto text-right  ">
                <div className="header-help-panel-home">
                  <h6 className="question-text t-justify">
                    <span className="question-title  me-2">پرسش شما :</span>
                    <span className='question-text'>{answer != "" ? answer.question : null}</span>
                  </h6>
                </div>

                <div className={find()[0] ? ' body-help-panel-home  height-40 d-flex align-content-center align-items-baseline' : ' body-help-panel-home  d-flex align-content-center align-items-baseline'}>

                  <div className='d-flex flex-column w-100 justify-content-end'>
                    {/* <p className={find()[0] ? 'remove-more-line answer-text answer-text-hight w-100 t-justify' : 'remove-more-line hh answer-text answer-text-hight w-100 t-justify'}>
                      {answer != "" ? answer.answer : null}
                    </p> */}
                    <p style={{ unicodeBidi: "plaintext", textAlign:"right"}} className={find()[0] ? 'remove-more-line answer-text answer-text-hight w-100 ' : 'remove-more-line hh answer-text answer-text-hight w-100'}>
                    {answer != "" ? answer.answer : null}
                    </p>
                    <pre style={{ unicodeBidi: "plaintext", whiteSpace: "pre-wrap", display: "none" , textAlign:"right"}} className={find()[0] ? 'remove-more-line answer-text answer-text-hight w-100' : 'remove-more-line hh answer-text answer-text-hight w-100'}>
                    {answer != "" ? answer.answer : null}
                    </pre>
                    {/* <div className='survey-dir  my-2'>
                  <Survey id={answer != "" ? answer.question_id : "main_question"} totalId={chatBitId} />
                </div> */}
                    <div className={find()[0] ? "d-none" : 'for-more  text-center text-sm-center '} onClick={(e) => showMore(e)}>
                      ...بیشتر
                    </div>
                  </div>


                  {/* {find()[1] ?
                null
                :
                <div className='survey-dir col-3  text-end  my-2 '>
                  <Survey id={answer != "" ? answer.question_id : "main_question"} totalId={chatBitId} />
                </div>

              } */}
                </div>
              </div>
            </div>
          </div>
          <div className='similar-box ' >
            {similarQuestion.length > 0 ? <div className="container justify-content-center align-content-center mx-auto"><h3 className='col-10 p-0 mx-auto text-white'> سوالات مشابه : </h3></div> : null}
            {similarQuestion.map(item => (

              <div key={item.id} className='similar-box container d-flex flex-column justify-content-center align-content-center mx-auto text-right'>
                <div className="row mt-3">
                  <div id="transition" className="d-flex flex-column col-10 p-0 mx-auto text-right  ">
                    <div className="header-help-panel-home">
                      <h6 className="question-text t-justify">
                        <span className="question-title ma me-2">پرسش دیگر :</span>
                        <span className='question-text'>
                          {item.question ? item.question : null}
                        </span>
                      </h6>
                    </div>
                    <div className={findSimilar(item.answer.length)[0] ? ' body-help-panel-home height-40 d-flex  align-content-center align-items-baseline' : ' body-help-panel-home  d-flex align-content-center align-items-baseline'}>
                      <div className='d-flex flex-column  justify-content-end'>
                        <p style={{ unicodeBidi: "plaintext", textAlign:"right"}}  className={findSimilar(item.answer.length)[0] ? 'remove-more-line answer-text answer-text-hight w-100' : 'remove-more-line hh answer-text answer-text-hight w-100'}>
                          {item.answer}
                        </p>
                        <pre style={{ unicodeBidi: "plaintext", whiteSpace: "pre-wrap", display: "none" , textAlign:"right"}} className={findSimilar(item.answer.length)[0] ? 'remove-more-line answer-text answer-text-hight w-100' : 'remove-more-line hh answer-text answer-text-hight w-100'}>
                          {item.answer}
                        </pre>
                        {/* <pre style={{ direction: "rtl", whiteSpace: "pre-wrap" }} className={findSimilar(item.answer.length)[0] ? 'remove-more-line answer-text answer-text-hight w-100 t-justify' : 'remove-more-line hh answer-text answer-text-hight w-100 t-justify'}>
                          {item.answer}
                        </pre> */}
                        {/* <div className='survey-dir  my-2'>
                      <Survey id={item.id} totalId={chatBitId} />
                    </div> */}
                        <div className={findSimilar(item.answer.length)[0] ? "d-none" : 'for-more  text-center text-sm-center '} onClick={(e) => showMore(e)}>
                          ...بیشتر
                        </div>

                      </div>



                      {/* {findSimilar(item.answer.length)[1] ?
                    null
                    :
                    <div className='survey-dir col-3  text-end  my-2 '>
                      <Survey id={item.id} totalId={chatBitId} />
                    </div>
                  } */}
                    </div>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </>

      }


      <Footer />
    </div>

  );
}

export default Results;